var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.0002H25M20.5 7.50023C20.8978 7.1024 21.4374 6.87891 22 6.87891C22.2786 6.87891 22.5544 6.93378 22.8118 7.04038C23.0692 7.14699 23.303 7.30324 23.5 7.50023C23.697 7.69721 23.8532 7.93106 23.9598 8.18843C24.0665 8.4458 24.1213 8.72165 24.1213 9.00023C24.1213 9.2788 24.0665 9.55465 23.9598 9.81202C23.8532 10.0694 23.697 10.3032 23.5 10.5002L11 23.0002L7 24.0002L8 20.0002L20.5 7.50023Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-icon.83753a4b2dadb3c7bddc968938727b81.svg";